var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.986816,
    width: 38,
    height: 38,
    rx: 19,
    fill: "#64C294"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.436 13.5868H21.1V11.9868H17.9V13.5868H16.564C15.98 13.5868 15.5 14.0668 15.5 14.6508V26.9148C15.5 27.5068 15.98 27.9868 16.564 27.9868H22.428C23.02 27.9868 23.5 27.5068 23.5 26.9228V14.6508C23.5 14.0668 23.02 13.5868 22.436 13.5868ZM18.7 26.3868V21.9868H17.1L20.3 15.9868V20.3868H21.9L18.7 26.3868Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/battery.aacfde394a50b1903a472c92c2d6c082.svg";
export { ForwardRef as ReactComponent };